// ChatTextarea.js - Isolated Chat Input Component
import React, {
  useRef,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from 'react'

const ChatTextarea = forwardRef((props, ref) => {
  const {
    value,
    onChange,
    onKeyPress,
    placeholder,
    className,
    disabled,
    isLoading,
    isStreaming,
    rows = '1',
  } = props

  const textareaRef = useRef(null)

  // Expose focus method to parent
  useImperativeHandle(ref, () => ({
    focus: () => {
      if (textareaRef.current && !textareaRef.current.disabled) {
        textareaRef.current.focus()
        const length = textareaRef.current.value.length
        textareaRef.current.setSelectionRange(length, length)
      }
    },
    blur: () => {
      if (textareaRef.current) {
        textareaRef.current.blur()
      }
    },
    get current() {
      return textareaRef.current
    },
    get disabled() {
      return textareaRef.current?.disabled || false
    },
  }))

  return (
    <textarea
      ref={textareaRef}
      value={value}
      onChange={onChange}
      onKeyPress={onKeyPress}
      placeholder={placeholder}
      className={className}
      rows={rows}
      disabled={disabled}
      style={{
        cursor: isLoading || isStreaming ? 'not-allowed' : 'text',
      }}
    />
  )
})

ChatTextarea.displayName = 'ChatTextarea'

export default ChatTextarea
